<div class="markdown-html center-content">
	<div>{{'workflow.test.completed' | translate}}</div>
	<ng-container *ngIf="(workflowItemKey.property$ | async) as results">
		<div class="centered" *ngIf="results.rotgruenblind">
			<table>
				<tbody>
				<tr>
					<td class="left-align">{{ 'workflow.test.colorWord.verbalReaction' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align">{{ results.zeit1 | number:'1.2-2' }} {{ 'unit.seconds.short' | translate }}</td>
				</tr>
				<tr><td colspan="3"></td></tr>
				<tr><td colspan="3" class="text-center">{{ 'workflow.test.colorWord.redGreenBlind' | translate }}</td></tr>
				</tbody>
			</table>
		</div>
		<div class="centered" *ngIf="!results.rotgruenblind">
			<table>
				<tbody>
				<tr>
					<td class="left-align">{{ 'workflow.test.colorWord.verbalReaction' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align">{{ results.zeit1 | number:'1.2-2' }} {{ 'unit.seconds.short' | translate }}</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'workflow.test.colorWord.cognitiveReaction' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align">{{ results.zeit2 | number:'1.2-2' }} {{ 'unit.seconds.short' | translate }}</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'workflow.test.colorWord.cognitiveAdaptability' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align">{{ results.zeit3 | number:'1.2-2' }} {{ 'unit.seconds.short' | translate }}</td>
				</tr>
				</tbody>
			</table>
		</div>
	</ng-container>
</div>
